import { getGrpcPromise } from '@monorepo/grpc';
import { DealService } from '@spilca/order_ts/v1/order_web/deal_web_pb_service';
import { ListDealDeliveryConditionRequest } from '@spilca/order_ts/v1/order/model_deal_pb';
import { dealsFilterConstructor } from '@monorepo/deals';

const getDealsDeliveryCondition = (d: any) => {
  const getDeliveryConditions = getGrpcPromise(
    DealService.ListDealDeliveryCondition
  );
  const [, params] = d.queryKey;
  const dealFilter = dealsFilterConstructor(params, d.active);
  const request = new ListDealDeliveryConditionRequest();
  request.setFilter(dealFilter);
  return getDeliveryConditions(request);
};

export default getDealsDeliveryCondition;
